export let fridayUppercase = "xkKq5";
export default {fridayUppercase};